"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeEmptyPlaylistNotification = exports.emptyPlaylistNotificationKey = void 0;
var _kernel_container_1 = __importDefault(require("../../container"));
var global_1 = require("../stores/global");
var notifications_1 = require("../stores/notifications");
exports.emptyPlaylistNotificationKey = "EmptyOfflinePlaylist";
function setOfflineMode() {
    var action = function (dispatch, getState) {
        var logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/setOfflineMode");
        var state = getState();
        if (!state.global.isConnected) {
            logger.debug("Already in offline mode, do not switch");
            return;
        }
        logger.info("Going to offline mode");
        dispatch((0, global_1.setConnected)(false));
        dispatch({ type: setOfflineMode.type });
    };
    action.type = setOfflineMode.type;
    return action;
}
setOfflineMode.type = "setOfflineMode";
exports.default = setOfflineMode;
function removeEmptyPlaylistNotification(state, dispatch) {
    var notification = selectNotification(state);
    if ((notification === null || notification === void 0 ? void 0 : notification.id) !== undefined)
        dispatch((0, notifications_1.removeNotification)(notification === null || notification === void 0 ? void 0 : notification.id));
}
exports.removeEmptyPlaylistNotification = removeEmptyPlaylistNotification;
function selectNotification(state) {
    var matchingNotifications = state.notifications.filter(function (notification) {
        return notification.key === exports.emptyPlaylistNotificationKey;
    });
    return matchingNotifications.length === 1 ? matchingNotifications[0] : null;
}
//# sourceMappingURL=setOfflineMode.js.map